import { OverlayTrigger, Tooltip } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TEACHER } from "../../../constants";
import {
  ReportCompetitionsService,
  ReportCompetitionsSubTopicService,
} from "../../../services/reports";
import * as actions from "../../../store/actions";
import * as configActions from "../../../store/config/actions";
import "./style.scss";
import { textIdentifier } from "../../../textIdentifier";

export default function ReportDashboardComponent() {
  const [isFetching, setIsFetching] = useState(true);
  const { userType, userData } = useSelector((state) => state.auth);
  const selectedClass = useSelector((state) => state.main.selectedClass);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [competition, setCompetitions] = useState([]);
  const [filteredCompetitions, setFilteredCompetitions] = useState([]);
  const {lang} = useSelector(state => state.main);

  const handleSelectClass = (classCode) => {
    if(!!sessionStorage.getItem("class_code")){
      sessionStorage.removeItem("class_code")
    }
    setFilteredCompetitions(
      competition.filter((item) => item.classes.includes(classCode))
    );
    dispatch(actions.selectClass({ code: classCode }));
  };

  const selectCompetition = async (competition, e) => {
    e.target.disabled = true;
    try {
      const res = await ReportCompetitionsSubTopicService(competition.id);
      dispatch(
        actions.selectCompetition({
          ...competition,
          subTopicsWiseReportData: res.data,
        })
      );
      navigate(`/report/${competition.id}`);
    } catch (error) {
      dispatch(configActions.showAlert(error?.data?.message));
      e.target.disabled = false;
    }
  };

  const handleFetchCompetitions = async () => {
    try {
      let selectedClass = sessionStorage.getItem("class_code");
      const res = await ReportCompetitionsService();
      setCompetitions(res.data);
      if (userType === TEACHER && res.data[0]?.classes?.length > 0) {
        if(!!selectedClass){
          const classCode = selectedClass;
          setFilteredCompetitions(
            res.data.filter((item) => item.classes.includes(classCode))
          );
          dispatch(actions.selectClass({ code: classCode }));
        }
        else{
          const classCode = res.data[0].classes[0];
          setFilteredCompetitions(
            res.data.filter((item) => item.classes.includes(classCode))
          );
          dispatch(actions.selectClass({ code: classCode }));
        }
      } else {
        setFilteredCompetitions(res.data);
      }
    } catch (error) {
      dispatch(configActions.showAlert(error?.data?.message));
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    handleFetchCompetitions();
  }, []);

  if (isFetching) {
    return null;
  }
  return (
    <div className="reports-dashboard-cards">
      <div className="card-groups">
        {userType === TEACHER && (
          <div className="classSelectionDropdown dropdown">
            <button
              className="btn dropdown-toggle"
              type="button"
              id="classSelectionDropdown"
              data-bs-toggle="dropdown"
              data-bs-offset="0,12"
              aria-expanded="false"
            >
              <div>
                <p>{textIdentifier['class-selected'][lang]}</p>
                <p>{selectedClass?.code}</p>
              </div>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="14"
                viewBox="0 0 22 14"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.11529 1.3153C1.5091 0.921611 2.04315 0.700448 2.59999 0.700448C3.15684 0.700448 3.69089 0.921611 4.08469 1.3153L11 8.2306L17.9153 1.3153C18.109 1.11473 18.3407 0.954746 18.5969 0.844687C18.8532 0.734628 19.1287 0.676697 19.4076 0.674274C19.6864 0.671851 19.9629 0.724984 20.221 0.830574C20.4791 0.936163 20.7136 1.0921 20.9107 1.28927C21.1079 1.48644 21.2638 1.72091 21.3694 1.979C21.475 2.23708 21.5281 2.51361 21.5257 2.79244C21.5233 3.07128 21.4654 3.34684 21.3553 3.60305C21.2453 3.85926 21.0853 4.09098 20.8847 4.2847L12.4847 12.6847C12.0909 13.0784 11.5568 13.2996 11 13.2996C10.4432 13.2996 9.9091 13.0784 9.5153 12.6847L1.11529 4.2847C0.721605 3.89089 0.500443 3.35684 0.500443 2.8C0.500443 2.24315 0.721605 1.70911 1.11529 1.3153Z"
                  fill="#0059B1"
                />
              </svg>
            </button>

            <ul
              className="dropdown-menu shadow"
              aria-labelledby="dropdownMenuButton1"
            >
              {userData?.classes?.map((_class) => (
                <li key={_class} onClick={() => handleSelectClass(_class)}>
                  {_class}
                </li>
              ))}
            </ul>
          </div>
        )}

        {Array.isArray(competition) &&
          filteredCompetitions.map((_, i) => (
            <div className="card" key={i}>
              <div className="card-body">
                <span className="card-title">
                  {i + 1}. {_.name}
                </span>
                {_.isReportReady ? 
                  ((!!selectedClass && _.disabled_classes.includes(selectedClass.code))?
                    <button
                      style={{ pointerEvents: "none" }}
                      disabled
                      className="btn-contained-disabled"
                    >
                      {textIdentifier["view-overall-report"][lang]}
                    </button>
                    :
                    <button
                      onClick={selectCompetition.bind(this, _)}
                      className="btn-contained"
                    >
                      {textIdentifier["view-overall-report"][lang]}
                    </button>
                  )
                : (
                  <OverlayTrigger
                    overlay={
                      <Tooltip id="tooltip-disabled">
                      {textIdentifier["report-shall-be-available-only-after-the-competition-has-ended"][lang]}
                      </Tooltip>
                    }
                  >
                    <span className="d-inline-block">
                      <button
                        style={{ pointerEvents: "none" }}
                        disabled
                        className="btn-contained-disabled"
                      >
                        {textIdentifier["view-overall-report"][lang]}
                      </button>
                    </span>
                  </OverlayTrigger>
                )}
              </div>
            </div>
          ))}

        {Array.isArray(competition) && filteredCompetitions.length === 0 && (
          <h6>{textIdentifier["no-reports-found"][lang]}</h6>
        )}
      </div>
    </div>
  );
}
